import { pick } from "lodash";
import { useState, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useIdentity } from "../components/IdentityProvider";

export const DEFAULT_SETTINGS = {
  allowConnectedEntitiesMonitor: false,
  allowPeopleMonitor: false,
  allowTKHomeMock: false,
  useV2WPRFindings: false,
  allowFraudSearch: false,
  allowDeepSearch: false,
};

export function getAdminSettings() {
  let store = { ...DEFAULT_SETTINGS };

  try {
    const prev = localStorage.getItem("adminSettings");
    store =
      prev != null
        ? // drop old crufty keys if we removed them from DEFAULT_SETTINGS
          {
            ...store,
            ...pick({ ...JSON.parse(prev) }, Object.keys(DEFAULT_SETTINGS)),
          }
        : store;
  } catch (e) {
    Sentry.captureException(e);
    // pass
  }

  return store;
}

export function setAdminSettings(nextSettings: typeof DEFAULT_SETTINGS) {
  localStorage.setItem("adminSettings", JSON.stringify(nextSettings));
}

export default function useAdminSettings() {
  const [settings, setSettings] = useState(() => getAdminSettings());

  useEffect(() => {
    setAdminSettings(settings);
  }, [settings]);

  return [settings, setSettings] as const;
}

export function useAllowFraudSearch() {
  const [settings] = useAdminSettings();
  const identity = useIdentity();

  const allowFraudSearch =
    [
      "Nomupay",
      "EMS",
      "Electronic Merchant Systems (APP TESTER)",
      "EMS Test",
    ].includes(identity.user?.accountName || "") || settings.allowFraudSearch;

  return allowFraudSearch;
}
